import { api } from "../../api/Middleware";
import {
  INSIGHTS_AI_PERFORMANCE_URL,
  INSIGHTS_GROWTH_URL,
  INSIGHTS_BOTTLENECKS_URL,
  INSIGHTS_TEAM_URL,
} from "../../api/Urls";

const BLOCK_URLS = {
  ai_performance: INSIGHTS_AI_PERFORMANCE_URL,
  growth: INSIGHTS_GROWTH_URL,
  bottlenecks: INSIGHTS_BOTTLENECKS_URL,
  team: INSIGHTS_TEAM_URL,
};

const buildParams = (filters) => {
  const params = {};
  if (filters?.dateStart) params.date_start = filters.dateStart;
  if (filters?.dateEnd) params.date_end = filters.dateEnd;
  if (filters?.compareWith) params.compare_with = filters.compareWith;
  return params;
};

// =============================================================
// Export — XLSX (recomendado, abas e cores) ou CSV (legacy)
// Sync; dispara download direto no browser.
// =============================================================
const MIME_BY_FORMAT = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  csv: "text/csv;charset=utf-8",
};

export const exportInsights = async (block, filters, format = "xlsx") => {
  const url = BLOCK_URLS[block];
  if (!url) throw new Error(`Bloco desconhecido: ${block}`);

  const response = await api.get(url, {
    params: { ...buildParams(filters), export: format },
    responseType: "blob",
  });

  const disposition = response.headers["content-disposition"] || "";
  const match = disposition.match(/filename="(.+?)"/);
  const filename = match
    ? match[1]
    : `relatorio-${block}-${filters?.dateStart || "periodo"}.${format}`;

  const blob = new Blob([response.data], { type: MIME_BY_FORMAT[format] || "application/octet-stream" });
  const objectUrl = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = objectUrl;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => window.URL.revokeObjectURL(objectUrl), 1000);
};

// Compat (chamadas antigas que passavam só block, filters)
export const exportInsightsCSV = (block, filters) => exportInsights(block, filters, "csv");
export const exportInsightsXLSX = (block, filters) => exportInsights(block, filters, "xlsx");

export const fetchAIPerformance = async (filters) => {
  const r = await api.get(INSIGHTS_AI_PERFORMANCE_URL, { params: buildParams(filters) });
  return r.data;
};

export const fetchGrowth = async (filters) => {
  const r = await api.get(INSIGHTS_GROWTH_URL, { params: buildParams(filters) });
  return r.data;
};

export const fetchBottlenecks = async (filters) => {
  const r = await api.get(INSIGHTS_BOTTLENECKS_URL, { params: buildParams(filters) });
  return r.data;
};

export const fetchTeam = async (filters) => {
  const r = await api.get(INSIGHTS_TEAM_URL, { params: buildParams(filters) });
  return r.data;
};
